<p>ms-notification-by-email works!</p>
